import { ExternalResource } from './externalResource';

export interface TenantMetaData {
  key: string;
  value: string;
  unit?: string;
}

export abstract class TenantGeneralData {
  id?: number;
  companyId?: number;
  dateCreated?: Date;
  lastUpdated?: Date;
  externalId?: string;
  externalSource?: string;
  externalResources?: Array<ExternalResource> = [];
  metaData?: TenantMetaData[] = [];

  constructor() {
    this.id = null;
    this.companyId = -1;
    this.dateCreated = null;
    this.lastUpdated = null;
    this.externalId = null;
    this.externalSource = null;
    this.externalResources = null;
    this.metaData = [];
  }
}
